import { normalizeEmotion } from "../../utils/emotion";
export
// 对齐当前主用板子：xingzhi-cube-1.54tft-wifi（240×240 方屏）
// 说明：后续如果要对齐 1.83（280×240 + gap_x=40），再做 profile 切换。
const PANEL_W = 240;
export const PANEL_H = 240;
export const CONTENT_W = 240;
export const CONTENT_H = 240;
export const PANEL_OFFSET_X = 0;
export const PANEL_OFFSET_Y = 0;
export const EMOJI_BY_EMOTION = {
  laughing: '😂',
  crying: '😭',
  angry: '😠',
  sad: '😔',
  loving: '😍',
  surprised: '😲',
  shocked: '😱',
  thinking: '🤔',
  relaxed: '😌',
  sleepy: '😴',
  silly: '😜',
  confident: '😏',
  delicious: '😋',
  confused: '🙄',
  neutral: '😶',
  happy: '🙂',
  embarrassed: '😳',
  winking: '😉',
  cool: '😎'
};
export const MIAOBAN_EAF_URLS = {
  happy: new URL('../../assets/miaoban_emotes/Happy.eaf', import.meta.url).toString(),
  sad: new URL('../../assets/miaoban_emotes/Sad.eaf', import.meta.url).toString(),
  angry: new URL('../../assets/miaoban_emotes/angry.eaf', import.meta.url).toString(),
  confused: new URL('../../assets/miaoban_emotes/confused.eaf', import.meta.url).toString(),
  shocked: new URL('../../assets/miaoban_emotes/shocked.eaf', import.meta.url).toString(),
  sleepy: new URL('../../assets/miaoban_emotes/sleep.eaf', import.meta.url).toString(),
  neutral: new URL('../../assets/miaoban_emotes/neutral.eaf', import.meta.url).toString(),
  winking: new URL('../../assets/miaoban_emotes/winking.eaf', import.meta.url).toString()
};
export function pickClassicStyle(emotion, accent) {
  const e = normalizeEmotion(emotion);
  const style = (() => {
    switch (e) {
      case 'happy':
        return {
          openness: 0.75,
          pupil: 0.9,
          iris: '#111827',
          brow: -10
        };
      case 'laughing':
        return {
          openness: 0.6,
          pupil: 0.75,
          iris: '#111827',
          brow: -14,
          jiggle: true
        };
      case 'loving':
        return {
          openness: 0.78,
          pupil: 0.85,
          iris: '#fb7185',
          brow: -8,
          blush: true
        };
      case 'embarrassed':
        return {
          openness: 0.82,
          pupil: 0.9,
          iris: '#111827',
          brow: -6,
          blush: true
        };
      case 'cool':
        return {
          openness: 0.7,
          pupil: 0.82,
          iris: '#111827',
          brow: -8,
          glasses: true
        };
      case 'winking':
        return {
          openness: 0.85,
          pupil: 0.9,
          iris: '#111827',
          brow: -10,
          wink: true
        };
      case 'thinking':
        return {
          openness: 0.88,
          pupil: 0.95,
          iris: '#111827',
          brow: -4
        };
      case 'confused':
        return {
          openness: 0.82,
          pupil: 0.95,
          iris: '#111827',
          brow: 4,
          asymBrow: true
        };
      case 'surprised':
        return {
          openness: 1.05,
          pupil: 0.7,
          iris: '#111827',
          brow: -18
        };
      case 'angry':
        return {
          openness: 0.72,
          pupil: 0.8,
          iris: '#111827',
          brow: 16,
          browColor: '#ef4444'
        };
      case 'sad':
        return {
          openness: 0.62,
          pupil: 0.9,
          iris: '#111827',
          brow: -2,
          browDown: true,
          tear: true
        };
      case 'sleepy':
        return {
          openness: 0.22,
          pupil: 0.95,
          iris: '#111827',
          brow: 0
        };
      case 'relaxed':
        return {
          openness: 0.48,
          pupil: 0.95,
          iris: '#111827',
          brow: -4
        };
      case 'silly':
        return {
          openness: 0.86,
          pupil: 0.85,
          iris: '#111827',
          brow: -6,
          jiggle: true,
          wink: true
        };
      case 'confident':
        return {
          openness: 0.78,
          pupil: 0.82,
          iris: '#111827',
          brow: 8,
          asymBrow: true
        };
      case 'delicious':
        return {
          openness: 0.9,
          pupil: 0.95,
          iris: '#111827',
          brow: -2,
          drool: true
        };
      case 'neutral':
      default:
        return {
          openness: 0.9,
          pupil: 1.0,
          iris: '#111827',
          brow: -2
        };
    }
  })();
  if (accent && typeof accent === 'string' && style?.iris === '#111827') {
    return {
      ...style,
      iris: accent
    };
  }
  return style;
}
export function clamp(v, lo, hi) {
  return Math.max(lo, Math.min(hi, v));
}
export function lerp(a, b, t) {
  return a + (b - a) * t;
}
export function randInt(maxExclusive) {
  if (maxExclusive <= 0) return 0;
  return Math.floor(Math.random() * maxExclusive);
}
export function hash01(input) {
  const s = String(input || '');
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0) % 1000 / 1000;
}
export function normalizeHexColor(input) {
  const s = String(input || '').trim().toLowerCase();
  if (!s) return null;
  if (/^#[0-9a-f]{6}$/.test(s)) return s;
  if (/^#[0-9a-f]{3}$/.test(s)) {
    const r = s[1];
    const g = s[2];
    const b = s[3];
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return null;
}
export function mixHexColors(baseHex, tintHex, tint = 0.25) {
  const base = normalizeHexColor(baseHex);
  const tintColor = normalizeHexColor(tintHex);
  if (!base) return tintColor || '#22c55e';
  if (!tintColor) return base;
  const t = clamp(Number(tint), 0, 1);
  const br = parseInt(base.slice(1, 3), 16);
  const bg = parseInt(base.slice(3, 5), 16);
  const bb = parseInt(base.slice(5, 7), 16);
  const tr = parseInt(tintColor.slice(1, 3), 16);
  const tg = parseInt(tintColor.slice(3, 5), 16);
  const tb = parseInt(tintColor.slice(5, 7), 16);
  const r = Math.round(br * (1 - t) + tr * t);
  const g = Math.round(bg * (1 - t) + tg * t);
  const b = Math.round(bb * (1 - t) + tb * t);
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
export function fillRoundRect(ctx, x, y, w, h, r, color) {
  ctx.fillStyle = color;
  const rr = Math.max(0, Math.min(r, Math.min(w, h) / 2));
  ctx.beginPath();
  ctx.moveTo(x + rr, y);
  ctx.lineTo(x + w - rr, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + rr);
  ctx.lineTo(x + w, y + h - rr);
  ctx.quadraticCurveTo(x + w, y + h, x + w - rr, y + h);
  ctx.lineTo(x + rr, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - rr);
  ctx.lineTo(x, y + rr);
  ctx.quadraticCurveTo(x, y, x + rr, y);
  ctx.closePath();
  ctx.fill();
}
export function fillTriangle(ctx, x0, y0, x1, y1, x2, y2, color) {
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.moveTo(x0, y0);
  ctx.lineTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.closePath();
  ctx.fill();
}
export function fillEllipse(ctx, cx, cy, rx, ry, color) {
  if (rx <= 0 || ry <= 0) return;
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fill();
}
export function fillCircle(ctx, cx, cy, r, color) {
  if (r <= 0) return;
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fill();
}
export function fillRect(ctx, x0, y0, x1, y1, color) {
  const xa = Math.min(x0, x1);
  const xb = Math.max(x0, x1);
  const ya = Math.min(y0, y1);
  const yb = Math.max(y0, y1);
  ctx.fillStyle = color;
  ctx.fillRect(xa, ya, xb - xa + 1, yb - ya + 1);
}
